export function CheckIcon() {
  return (
    <svg className="w-4 h-4 text-[#40e7a2]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 6L9 17l-5-5"/>
    </svg>
  )
}

export function ShieldIcon() {
  return (
    <svg className="w-4 h-4 text-[#8da0d0]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  )
}

export function BoltIcon() {
  return (
    <svg className="w-4 h-4 text-[#8da0d0]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/>
    </svg>
  )
}

export function SparkIcon() {
  return (
    <svg className="w-4 h-4 text-[#8da0d0]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z"/>
    </svg>
  )
}
